module.exports = __webpack_public_path__ + "static/img/weixin.c705d21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weixin.png
// module id = AVav
// module chunks = 29